// src/views/kiddo-games/drag-letters/RulesOfTheGame.tsx
import React from 'react';
import GameRulesText from '../../../components/InfoButton/GameRulesText';

const RulesOfTheGame = () => (
  <>
    <p style={{ color: 'darkslategray', margin: '0' }}>
      <GameRulesText game="dragLetters" />
    </p>
  </>
);

export default RulesOfTheGame;
